
/**
 * Module dependencies.
 */

import { Component, ReactNode } from 'react';

/**
 * `Props` type.
 */

type Props = {
  children?: ReactNode;
  enabled: boolean;
};

/**
 * Set body overflow.
 */

function setBodyOverflow(enabled: boolean) {
  const body = document.body;

  if (!body) {
    return;
  }

  body.style.overflow = enabled ? '' : 'hidden';
}

/**
 * Prevent default event.
 */

function preventDefaultTouchmove(event: Event) {
  event.preventDefault();
}

/**
 * Add prevent default touchmove event listener.
 */

function disableBodyTouchmove() {
  const body = document.body;

  if (!body) {
    return;
  }

  body.addEventListener('touchmove', preventDefaultTouchmove);
}

/**
 * Remove prevent default touchmove event listener.
 */

function enableBodyTouchmove() {
  const body = document.body;

  if (!body) {
    return;
  }

  body.removeEventListener('touchmove', preventDefaultTouchmove);
}

/**
 * `BodyScroll` component.
 */

class BodyScroll extends Component<Props> {

  /**
   * Set body scroll.
   */

  setBodyScroll(enabled: boolean) {
    setBodyOverflow(enabled);

    if (enabled) {
      enableBodyTouchmove();
    } else {
      disableBodyTouchmove();
    }
  }

  /**
   * Component did mount.
   */

  componentDidMount() {
    if (!this.props.enabled) {
      this.setBodyScroll(false);
    }
  }

  /**
   * Component did update.
   */

  componentDidUpdate(previousProps: Props) {
    const { enabled } = this.props;

    if (enabled === previousProps.enabled) {
      return;
    }

    this.setBodyScroll(enabled);
  }

  /**
   * Component will unmount.
   */

  componentWillUnmount() {
    this.setBodyScroll(true);
  }

  /**
   * Render.
   */

  render() {
    return this.props.children || null;
  }

}

/**
 * Export `BodyScroll` component.
 */

export default BodyScroll;
